<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <navbar></navbar>
    <notifications></notifications>
    <side-bar>
      <!-- <user-menu></user-menu> -->
      <!-- <mobile-menu></mobile-menu> -->
      <template slot-scope="props" slot="links">
        <sidebar-item
          v-if="
            currentWorkspace &&
            currentWorkspace.workspace_type != 'Limited Partner'
          "
          :link="{
            name: 'Dashboard',
            materialClass: 'material-icons-outlined',
            materialIcon: 'dashboard',
            path: `/${$route.params.account_id}/${$route.params.workspace_id}/dashboard/overview`,
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="
            currentWorkspace &&
            currentWorkspace.workspace_type == 'Limited Partner'
          "
          :link="{
            name: 'Dashboard',
            materialClass: 'material-icons-outlined',
            materialIcon: 'dashboard',
            path: `/${$route.params.account_id}/${$route.params.workspace_id}/lpDashboard`,
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="
            currentWorkspace &&
            currentWorkspace.workspace_type != 'General Partner' &&
            showFundTab &&
            currentWorkspace.workspace_type == 'Limited Partner'
          "
          :link="{
            name: 'Summary',
            materialClass: 'material-icons-outlined',
            materialIcon: 'monetization_on',
            path: `/${$route.params.account_id}/${$route.params.workspace_id}/lpSummary`,
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="
            currentWorkspace &&
            currentWorkspace.workspace_type == 'General Partner' &&
            showFundTab &&
            currentWorkspace.workspace_type != 'Limited Partner'
          "
          :link="{
            name: 'Fund',
            materialClass: 'material-icons-outlined',
            materialIcon: 'monetization_on',
            path: `/${$route.params.account_id}/${$route.params.workspace_id}/thesis`,
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="
            showDiligenceTab &&
            currentWorkspace &&
            currentWorkspace.workspace_type != 'Limited Partner'
          "
          :link="{
            name: 'Diligence',
            materialClass: 'material-icons-outlined',
            materialIcon: 'diligence',
            path: `/${$route.params.account_id}/${$route.params.workspace_id}/diligence`,
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="showPortfolioTab"
          :link="{
            name: 'Portfolio',
            materialClass: 'material-icons-outlined',
            materialIcon: 'work_outline',
            path: `/${$route.params.account_id}/${$route.params.workspace_id}/portfolio`,
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="showTodoTab"
          :link="{
            name: 'To-Do',
            materialClass: 'material-icons-outlined',
            materialIcon: 'assignment_turned_in',
            path: `/${$route.params.account_id}/${$route.params.workspace_id}/todos`,
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="showPeopleTab"
          :link="{
            name: 'People',
            materialClass: 'material-icons-outlined',
            materialIcon: 'people_outline',
            path: `/${$route.params.account_id}/${$route.params.workspace_id}/people`,
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="
            showRegistrarTab &&
            currentWorkspace &&
            currentWorkspace.workspace_type != 'Limited Partner'
          "
          :link="{
            name: 'Registrar',
            materialClass: 'material-icons-outlined',
            materialIcon: 'list_alt',
            path: `/${$route.params.account_id}/${$route.params.workspace_id}/transactions`,
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="
            showDocumentsTab &&
            currentWorkspace &&
            currentWorkspace.workspace_type != 'Limited Partner'
          "
          :link="{
            name: 'Documents',
            materialClass: 'material-icons-outlined',
            materialIcon: 'library_books',
            path: `/${$route.params.account_id}/${$route.params.workspace_id}/documents`,
          }"
        ></sidebar-item>
        <!--Search disabled for now-->
        <!--<sidebar-item :link="{name: 'Search', icon: 'nc-icon nc-zoom-split', path: '/search'}">
        </sidebar-item>-->
        <!-- <sidebar-item :link="{name: 'Components', icon: 'nc-icon nc-app'}">
          <sidebar-item :link="{name: 'Buttons', path: '/components/buttons'}"></sidebar-item>
          <sidebar-item :link="{name: 'Grid System', path: '/components/grid-system'}"></sidebar-item>
          <sidebar-item :link="{name: 'Panels', path: '/components/panels'}"></sidebar-item>
          <sidebar-item :link="{name: 'Sweet Alert', path: '/components/sweet-alert'}"></sidebar-item>
          <sidebar-item :link="{name: 'Notifications', path: '/components/notifications'}"></sidebar-item>
          <sidebar-item :link="{name: 'Icons', path: '/components/icons'}"></sidebar-item>
          <sidebar-item :link="{name: 'Typography', path: '/components/typography'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Forms', icon: 'nc-icon nc-notes'}">
          <sidebar-item :link="{name: 'Regular Forms', path: '/forms/regular'}"></sidebar-item>
          <sidebar-item :link="{name: 'Extended Forms', path: '/forms/extended'}"></sidebar-item>
          <sidebar-item :link="{name: 'Validation Forms', path: '/forms/validation'}"></sidebar-item>
          <sidebar-item :link="{name: 'Wizard', path: '/forms/wizard'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Tables', icon: 'nc-icon nc-paper-2'}">
          <sidebar-item :link="{name: 'Regular Tables', path: '/table-list/regular'}"></sidebar-item>
          <sidebar-item :link="{name: 'Extended Tables', path: '/table-list/extended'}"></sidebar-item>
          <sidebar-item :link="{name: 'Paginated Tables', path: '/table-list/paginated'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Maps', icon: 'nc-icon nc-pin-3'}">
          <sidebar-item :link="{name: 'Google Maps', path: '/maps/google'}"></sidebar-item>
          <sidebar-item :link="{name: 'Full Screen Maps', path: '/maps/full-screen'}"></sidebar-item>
          <sidebar-item :link="{name: 'Vector Maps', path: '/maps/vector-map'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Charts', icon: 'nc-icon nc-chart-bar-32', path: '/admin/charts'}"></sidebar-item>
        <sidebar-item :link="{name: 'Calendar', icon: 'nc-icon nc-single-copy-04', path: '/admin/calendar'}"></sidebar-item>
        -->
        <!--<sidebar-item :link="{name: 'Pages', icon: 'nc-icon nc-puzzle-10'}">
          <sidebar-item :link="{name: 'User Page', path: '/pages/user'}"></sidebar-item>
          <sidebar-item :link="{name: 'Login Page', path: '/login'}"></sidebar-item>
          <sidebar-item :link="{name: 'Register', path: '/register'}"></sidebar-item>
          <sidebar-item :link="{name: 'Excel Upload', path: '/XlsImporter'}"></sidebar-item>
        </sidebar-item>-->
      </template>
    </side-bar>
    <div id="main-panel" class="main-panel">
      <!-- <top-navbar></top-navbar> -->
      <div style="background-color: white">
        <infobox
          v-if="infoBoxMessage.show"
          v-bind:message="infoBoxMessage"
        ></infobox>
      </div>
      <dashboard-content @click.native="toggleSidebar"></dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import { InfoBox } from "src/components/index";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import UserMenu from "./Extra/UserMenu.vue";
import store from "../../../store";
import { mapGetters } from "vuex";
import NavbarNew from "../Layout/NavbarNew";
export default {
  components: {
    TopNavbar,
    infobox: InfoBox,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    UserMenu,
    [NavbarNew.name]: NavbarNew,
  },
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("workspace", ["currentWorkspace"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions"]),
    ...mapGetters("lpAllocations", ["thesisData"]),
    infoBoxMessage: () => {
      let data = store.getters["infobox/infoBoxMessage"];
      return data;
    },
    showPortfolioTab() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "SHOW PORTFOLIO TAB") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showFundTab() {
      let status = false;
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "SHOW FUND TAB") {
          return item;
        }
      });
      let addThesisIndex = rolePermissions.findIndex((item) => {
        if (item == "ADD THESIS") {
          return item;
        }
      });
      if (index >= 0) {
        if (addThesisIndex >= 0) {
          status = true;
        } else {
          status = this.thesisData && this.thesisData.length > 0 ? true : false;
        }
      } else {
        status = false;
      }
      return status;
    },
    showDiligenceTab() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "SHOW DILIGENCE TAB") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showRegistrarTab() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "SHOW REGISTRAR") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showDocumentsTab() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "SHOW DOCUMENTS TAB") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showTodoTab() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "SHOW TODO TAB") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showPeopleTab() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "SHOW PEOPLE TAB") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
  },
  mounted() {
    this.$sidebar.showSidebar = true;
    this.$sidebar.displaySidebar(true);
    //this.$sidebar.toggleMinimize();
  },
  // destroyed() {
  //   this.$sidebar.toggleMinimize();
  // },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        //this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
<style>
.fa-icon {
  font-size: 16px !important;
  line-height: 28px;
}
</style>